<template>
    <div class="container-fluid p-0  ">
    <div class="w-100 home-header p-0">
        <div class="home-header-content">
            Observatorio Oceanográﬁco Móvil de la Región de Murcia
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-lg-6">
            <div class="home-body-content">
            <p><b>Descripción proyecto</b></p>
            <p style="text-align: justify;">OOMMUR plantea la construcción de un sistema de observación oceanográfico móvil compuesto por equipos que integran 
                las últimas tecnologías submarinas, con las que obtener toda la información necesaria, georrefenciada y clasificada, de las áreas marinas objeto de análisis.
                <br><br>
                El proyecto tiene un doble objetivo. Por un lado, el desarrollo de una plataforma tecnológica abierta para la 
                observación del medio marino, con el que situar productos tecnológicos de empresas murcianas en los mercados internacionales, 
                y por otro lado, el sistema nace para ser la herramienta fundamental para custodiar las aguas litorales 
                murcianas, obteniendo información minuciosa, clasificada y georreferenciada de las zonas de interés.
                <br><br>
                En el proyecto participan desde equipos de investigación de universidades como UPCT o la UMU, el Centro Tecnológico Naval y del Mar (CTN), empresas tecnológicas del sector marino y marítimo como 
                Técnicas Cartagena, MicroDesign, Casco Antiguo y Electro Canteras.
             </p>
            </div>
            <router-link class="position-relative mt-5 pt-5" tag="div" to="/login" exact>
                <button class="btn btn-primary btn-home-login">Login</button>
            </router-link>  
        </div>
        <div class="col-lg-6">
            <div class="home-body-img" style="-webkit-box-shadow: 3px 3px 5px 6px #ccc; -moz-box-shadow: 3px 3px 5px 6px #ccc; box-shadow: 3px 3px 5px 6px #ccc;">
                <img  class="image-cover" :src="require('@/assets/MMblue.png')" alt="home-picture"/>
            </div> 
        </div>
    </div>
    </div>
</template>

<script>
  export default {
    data(){
      return {
      }
    },
    methods: {
    },
    beforeMount(){
      //this.$store.dispatch('refresh_token')
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/home.vue